/** @format */

import PinIcon from '@/assets/joivy_poi_miniature_pink.svg';
import { TTranslation, useAppTranslation } from '@/i18n/declarations';
import { isNil } from 'lodash';
import React, { useMemo } from 'react';
import type { TBuildingRoomsMarker, TRoomMarker } from '../../../api/apiListingMapMarkers';
import { usePageListingContext } from '../../page/PageListing/components/PageListingContext';
import BuildingIcon from './BuildingIcon';
import { PinIconContainer, PinSingleIconContainer } from './Pin.style';

interface PinProps {
  dataMarker: number;
}

interface RoomPriceMakersPinProps extends PinProps {
  data: TRoomMarker | TBuildingRoomsMarker;
  selected?: boolean | null;
}

export const SinglePin: React.FC<PinProps> = ({ dataMarker }) => {
  return (
    <PinSingleIconContainer data-marker={dataMarker}>
      <img src={PinIcon} alt="Map pin" />
    </PinSingleIconContainer>
  );
};

export const RoomPriceMakersPin: React.FC<RoomPriceMakersPinProps> = ({ selected = false, dataMarker, data }) => {
  const { t } = useAppTranslation();
  const pageListingContext = usePageListingContext();

  const isBuilding = 'rooms' in data && !isNil(data.rooms);

  const newSelected = useMemo(() => {
    if (!pageListingContext) return selected;

    if (
      isBuilding &&
      data.position.latitude === pageListingContext.hoveredRoom?.coords.lat &&
      data.position.longitude === pageListingContext.hoveredRoom?.coords.lng
    ) {
      return true || selected;
    }

    if (!isBuilding && 'code' in data && data.code === pageListingContext.hoveredRoom?.code) {
      return true || selected;
    }

    return selected;
  }, [selected, pageListingContext, isBuilding]);

  return (
    <PinIconContainer
      $selected={newSelected}
      data-marker={dataMarker}
      title={t('plp.map_pin_show_room' as TTranslation, {
        // @ts-ignore
        code: isBuilding ? 'building' : data?.code,
      })}
    >
      {isBuilding ? (
        <span>
          <BuildingIcon style={{ width: 18, transition: 'all 0.3s ease' }} fill={newSelected ? 'white' : 'black'} />
          <small>From</small> €{Math.min(...data.rooms.map(s => s.price))}
        </span>
      ) : (
        <>
          {/* @ts-ignore */}
          <span>€{data.price}</span>
        </>
      )}
    </PinIconContainer>
  );
};
